export default __webpack_public_path__ + "static/media/review-m.5ff2ea62.jpg";